/**
 * Feature catalog — shared between backend (permissions/plans) and frontend (menu, forms).
 * Keep the `key` stable — it's persisted in Mongo and referenced by URL/route paths.
 */

export const FEATURES = [
  { key: "kanban",           label: "Kanban",         path: "/kanban" },
  { key: "chat",             label: "Chat",           path: "/chat" },
  { key: "contacts",         label: "Contatos",       path: "/contacts" },
  { key: "reports",          label: "Relatórios",     path: "/reports" },
  { key: "ai",               label: "IA",             path: "/ai" },
  { key: "chatbot",          label: "Chatbot",        path: "/chatbot" },
  { key: "mass_sending",     label: "Envio em Massa", path: "/mass-sending" },
  { key: "team",             label: "Equipe",         path: "/team" },
  { key: "work_schedules",   label: "Jornada",        path: "/work-schedules" },
  { key: "templates",        label: "Templates",      path: "/templates" },
  { key: "business_hours",   label: "Horário",        path: "/business-hours" },
  { key: "closure_reasons",  label: "Motivos",        path: "/closure-reasons" },
  { key: "anti_ban",         label: "Anti-ban",       path: "/anti-ban" },
  { key: "connections",      label: "Conexões",       path: "/connections" },
  { key: "general_settings", label: "Ajustes Gerais", path: "/general-settings" },
  { key: "api_integration", label: "API",             path: "/integrations" },
  { key: "help",             label: "Ajuda",          path: "/help" },
  { key: "suggestions",      label: "Sugestão",       path: "/suggestions" },
];

/** Default permissions for a new attendant (basic operational access only). */
export const DEFAULT_ATTENDANT_PERMISSIONS = [
  "kanban", "chat", "contacts", "help", "suggestions",
];

/** All feature keys — used to enable-all in plans / grant-all for owners. */
export const ALL_FEATURE_KEYS = FEATURES.map((f) => f.key);
